module.exports = __webpack_public_path__ + "static/weather-tablet-dark-plp-6175af86aa44538fea68ca190db60208.png";